<template>
  <div>
    <v-app-bar
      app
      flat
      color="white"
      elevate-on-scroll
      height="72"
      class="te-nav-bar"
    >
      <v-container class="d-flex align-center flex-grow-1 py-0 px-4 px-sm-6">
        <v-img
          class="te-nav-logo"
          src="../assets/logo.png"
          lazy-src="../assets/logo.png"
          alt="Toeato"
          max-height="48"
          max-width="48"
          @click="goHome"
        />
        <span class="te-nav-brand d-none d-sm-flex ml-3">Toeato</span>
        <v-spacer />
        <nav v-if="$vuetify.breakpoint.mdAndUp" class="d-flex align-center te-nav-links">
          <v-btn
            v-for="link in navLinks"
            :key="link.to"
            text
            class="te-nav-link"
            :to="link.to"
            exact
            active-class="te-nav-link--active"
          >
            {{ link.label }}
          </v-btn>
          <v-btn
            color="primary"
            depressed
            class="ml-2"
            target="_blank"
            href="https://play.google.com/store/apps/details?id=com.toeato.toeato"
          >
            Get the app
          </v-btn>
        </nav>
        <v-btn
          v-if="$vuetify.breakpoint.smAndDown"
          icon
          aria-label="Open menu"
          @click="drawer = true"
        >
          <v-icon>mdi-menu</v-icon>
        </v-btn>
      </v-container>
    </v-app-bar>

    <v-navigation-drawer
      v-model="drawer"
      fixed
      temporary
      right
      width="280"
      class="te-nav-drawer"
    >
      <v-list nav dense class="pt-4">
        <v-list-item
          v-for="link in navLinks"
          :key="'m-' + link.to"
          :to="link.to"
          @click="drawer = false"
        >
          <v-list-item-content>
            <v-list-item-title>{{ link.label }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          href="https://play.google.com/store/apps/details?id=com.toeato.toeato"
          target="_blank"
          @click="drawer = false"
        >
          <v-list-item-content>
            <v-list-item-title class="primary--text font-weight-medium">
              Get the app
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
export default {
  data: () => ({
    drawer: false,
    navLinks: [
      { label: "Home", to: "/" },
      { label: "About", to: "/about" },
      { label: "Contact", to: "/contact" },
      { label: "Careers", to: "/careers" },
      { label: "Privacy", to: "/privacy-policy" },
      { label: "Delete account", to: "/delete_account" },
    ],
  }),
  methods: {
    goHome() {
      if (this.$route.path !== "/") {
        this.$router.push("/");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/tokens";

.te-nav-bar {
  border-bottom: 1px solid $te-border !important;
  box-shadow: 0 1px 0 rgba(15, 23, 42, 0.04) !important;
}

.te-nav-logo {
  border-radius: $te-radius-sm;
  cursor: pointer;
  flex-shrink: 0;
}

.te-nav-brand {
  font-size: 1.125rem;
  font-weight: 600;
  letter-spacing: -0.02em;
  color: $te-text;
}

.te-nav-link {
  font-weight: 500 !important;
  color: $te-text-muted !important;
  border-radius: $te-radius-sm !important;
  min-width: 0 !important;
}

.te-nav-link--active {
  color: $te-primary !important;
  background: rgba($te-primary, 0.08) !important;
}
</style>
